var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 96.667 96.666",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M48.333 73.296c9.519 0 17.263-7.744 17.263-17.262V17.262C65.596 7.743 57.852 0 48.333 0c-9.519 0-17.262 7.743-17.262 17.262v38.773c0 9.518 7.743 17.261 17.262 17.261z",
    fill: "#81A63D",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.078 45.715h-3.437a2 2 0 0 0-2 2v7.029c0 12.3-10.008 22.308-22.309 22.308S26.025 67.044 26.025 54.744v-7.029a2 2 0 0 0-2-2h-3.437a2 2 0 0 0-2 2v7.029c0 14.707 11.433 27.667 26.026 29.506v4.98h-15.35a2 2 0 0 0-2 2v3.436a2 2 0 0 0 2 2h38.138a2 2 0 0 0 2-2V91.23a2 2 0 0 0-2-2H52.051v-4.98c14.594-1.838 26.026-14.799 26.026-29.506v-7.029c.001-1.105-.895-2-1.999-2z",
    fill: "#81A63D",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMic);
export default __webpack_public_path__ + "static/media/mic.ebf8763221b851b471f7ce46c31ef00b.svg";
export { ForwardRef as ReactComponent };